import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { CommonState } from "@obg/ngx.common";
import { AppError, MarketSelector, ProductType } from "@obg/ngx.core";
import { RouteSelector } from "@obg/ngx.router";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { RegistrationFeatureState } from "../../state";
import { RegistrationAction } from "../registration.action";
import { RegistrationResponse } from "../registration.model";

import { REGISTRATION_WITH_SMART_ID_ACTION_TYPE } from "./registration-with-smart-id.action";
import {
	SmartIdCompleteRegistrationPayload,
	SmartIdSimpleRegistrationPayload,
} from "./registration-with-smart-id.model";
import { RegistrationWithSmartIdService } from "./registration-with-smart-id.service";

@Injectable()
export class SmartIdRegistrationEffect {
	getSmartIdSimpleIdRegistrationToken$ = createEffect(() =>
		this.actions$.pipe(
			ofType(REGISTRATION_WITH_SMART_ID_ACTION_TYPE.getSmartIdSimpleRegistrationToken),
			map((x: ActionWithPayload<SmartIdSimpleRegistrationPayload>) => x.payload),
			withLatestFrom(
				this.store.select(this.marketSelector.getCurrent()),
				this.store.select<{ product: ProductType | undefined } | undefined>(RouteSelector.getQueryParams)
			),
			switchMap(([request, market, params]) =>
				this.smartIdservice.registerSmartIdSimple(request, market, params?.product).pipe(
					map((response: RegistrationResponse) =>
						this.action.getRegistrationTokenSuccess(response, request.credential)
					),
					catchError((response: AppError) => of(this.action.getRegistrationTokenFail(response)))
				)
			)
		)
	);

	getSmartIdCompleteIdRegistrationToken$ = createEffect(() =>
		this.actions$.pipe(
			ofType(REGISTRATION_WITH_SMART_ID_ACTION_TYPE.getSmartIdCompleteRegistrationToken),
			map((x: ActionWithPayload<SmartIdCompleteRegistrationPayload>) => x.payload),
			withLatestFrom(
				this.store.select(this.marketSelector.getCurrent()),
				this.store.select<{ product: ProductType | undefined } | undefined>(RouteSelector.getQueryParams)
			),
			switchMap(([request, market, params]) =>
				this.smartIdservice.registerSmartIdComplete(request, market, params?.product).pipe(
					map((response: RegistrationResponse) =>
						this.action.getRegistrationTokenSuccess(response, request.credential)
					),
					catchError((response: AppError) => of(this.action.getRegistrationTokenFail(response)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private action: RegistrationAction,
		private smartIdservice: RegistrationWithSmartIdService,
		private marketSelector: MarketSelector,
		private store: Store<RegistrationFeatureState & CommonState>
	) {}
}
